import landingVideo from "../../assets/video/landing-video.mp4"
import { motion } from "framer-motion"
import { useRef } from "react"
import CampaignDetailLandingCard from "./campaign-detail-landing-card/campaign-detail-landing-card"
import EmpParallax from "../../components/shared/emp-parallax/emp-parallax"
import StyledButton from "../../components/shared/styled-button"
import { EmpLandingNavbar } from "../../components/template/emp-landing-navbar/emp-landing-navbar"
import useLeftReviewScrollAnimation from "../../hooks/useLeftReviewScrollAnimation"
import CampaignTalentsLandingCard from "./campaign-talents-landing-card/campaign-talents-landing-card"
import CampaignTasksLandingCard from "./campaign-tasks-landing-card/campaign-tasks-landing-card"
import CtaLandingCard from "./cta-landing-card/cta-landing-card"
import SocialMediaAnalyticsLandingCard from "./social-media-analytics-landing-card/social-media-analytics-landing-card"
import SocialMediaComposeLandingCard from "./social-media-compose-landing-card/social-media-compose-landing-card"
import TalentLandingReel from "./talent-landing-reel/talent-landing-reel"
import SocialMediaCalendarLandingCard from "./social-media-calendar-landing-card/social-media-calendar-landing-card"
import "./landing-page.scss";
import { useNavigate } from "react-router-dom"

type navbarThemeType = "mixed" | "gray" | "black"
// #191d20
function LandingPage() {
    const navigate = useNavigate();
    const socialMediaSectionAnimRef = useRef<HTMLDivElement>(null)
    const socialMediaSectionAnimSpecs = useLeftReviewScrollAnimation(socialMediaSectionAnimRef)

    const influencerSectionAnimRef = useRef<HTMLDivElement>(null)
    const influencerSectionAnimSpecs = useLeftReviewScrollAnimation(influencerSectionAnimRef)

    const campaignSectionAnimRef = useRef<HTMLDivElement>(null)
    const campaignSectionAnimSpecs = useLeftReviewScrollAnimation(campaignSectionAnimRef)

    return (
        // Hook Section
        <>
            <section className='page-wrapper bg-gray-1000'>
                <div className="hero-section bg-gray-1000">
                    <div className='colored-overlay'>
                        <div className='content'>

                            <h1 className='heading'>One platform</h1>
                            <h1 className='heading'>endless marketing possibilities</h1>
                            <p className='subtitle'>Plan, execute, and measure the success of your marketing campaigns.</p>
                            <div className="mt-5">
                                <StyledButton
                                    text='Enterprise Account'
                                    onClick={() => { navigate("/enterprise-interest")}} />
                            </div>
                        </div>
                    </div>
                    {/* <img alt='Landing Page' src={landingImage} /> */}
                    <div style={{ height: "100%" }} dangerouslySetInnerHTML={{
                        __html: `<video class="landing-video" autoplay loop muted playsinline>
        <source src=${landingVideo} type="video/mp4" />
        Your browser does not support the video tag.
  </video>`,
                    }}>
                    </div>
                    {/* <video autoPlay={true} src={landingVideo} muted loop /> */}
                </div>
            </section>

            {/* Social Media Marketing Section */}
            <section className="page-wrapper bg-gray-850 bg-gray-850">
                <div className="social-media-section bg-gray-850">
                    <motion.div className="section-text-wrapper"
                        ref={socialMediaSectionAnimRef}
                        variants={socialMediaSectionAnimSpecs.variants}
                        initial={socialMediaSectionAnimSpecs.initial}
                        animate={socialMediaSectionAnimSpecs.control}
                    >
                        <div className='section-heading-lg'>
                            <h1 className="section-heading">Manage Your Social Media</h1>
                            <h1 className="section-heading alt">Across all major platforms</h1>
                        </div>
                        <div className='section-heading-mobile'>
                            <span style={{ lineHeight: "2.2em" }}><h1 className="section-heading inline">Manage Your Social Media </h1><h1 className="section-heading alt inline">Across all major platforms</h1></span>
                        </div>
                        <p className='section-description color-gray-200'>Manage social media campaigns and track performance in one place. No need for multiple accounts or tools.</p>
                    </motion.div>
                    <EmpParallax>
                        <>
                            <div className='cards-hstack'>
                                {/* Scheduler Card Section */}
                                <SocialMediaCalendarLandingCard />

                                {/* Compose Card Section */}
                                <SocialMediaComposeLandingCard />
                            </div>
                            <SocialMediaAnalyticsLandingCard className="mt-8" />
                        </>
                    </EmpParallax>
                </div>
            </section>



            <section className="page-wrapper bg-gray-850 bg-gray-850">
                <div className="influencer-section bg-gray-850">
                    <motion.div className="section-text-wrapper"
                        ref={influencerSectionAnimRef}
                        variants={influencerSectionAnimSpecs.variants}
                        initial={influencerSectionAnimSpecs.initial}
                        animate={influencerSectionAnimSpecs.control}>

                        <div className='section-heading-lg'>
                            <h1 className="section-heading">Gain Access to</h1>
                            <h1 className="section-heading alt">Top Influencers</h1>
                        </div>
                        <div className='section-heading-mobile'>
                            <span style={{ lineHeight: "2.2em" }}><h1 className="section-heading inline">Gain Access to </h1><h1 className="section-heading alt inline">Top Influencers</h1></span>
                        </div>
                        <p className='section-description color-gray-200'>Access to top influencers in your industry, making it easy for you to create and launch campaigns that will make a splash.</p>
                    </motion.div>
                    <div className='mt-6'>
                        <TalentLandingReel />
                    </div>

                </div>
            </section>


            {/* Campaigns and Influencer Section */}
            <section className="page-wrapper bg-gray-850 bg-gray-850">
                <div className="campaign-section bg-gray-850">
                    <motion.div className="section-text-wrapper"
                        ref={campaignSectionAnimRef}
                        variants={campaignSectionAnimSpecs.variants}
                        initial={campaignSectionAnimSpecs.initial}
                        animate={campaignSectionAnimSpecs.control}>
                        <div className='section-heading-lg'>
                            <h1 className="section-heading">Launch Campaigns in a</h1>
                            <h1 className="section-heading alt">Simple 3 Step Process</h1>
                        </div>
                        <div className='section-heading-mobile'>
                            <span style={{ lineHeight: "2.2em" }}><h1 className="section-heading inline">Launch Campaigns in a  </h1><h1 className="section-heading alt inline">Simple 3 Step Process</h1></span>
                        </div>
                        <p className='section-description color-gray-200'>We streamline the campaign creation process and allows you to easily reach your target audience and achieve your marketing goals. </p>
                    </motion.div>

                    <div className='cards-hstack mt-10'>
                        {/* Campaign Details Card Section */}
                        <div className='campaign-detail-card'>
                            <CampaignDetailLandingCard />
                        </div>

                        {/* Campaign Tasks Card Section */}
                        <div className='campaign-task-card'>
                            <CampaignTasksLandingCard />
                        </div>
                    </div>

                    <div className='campaign-talent-card'>
                        <CampaignTalentsLandingCard />
                    </div>
                </div>
            </section>


            <section className="page-wrapper bg-gray-850 bg-gray-850">
                <div className="cta-section bg-gray-850">
                    <CtaLandingCard />
                </div>
            </section>
        </>
    );
}

export default LandingPage;
